export default __webpack_public_path__ + "static/media/selfcare.4698d5e6.jpg";